// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var About = require("./about");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var GraphqlClientQuery = require("./graphqlClientQuery");

var component = ReasonReact.reducerComponent("App");

function urlToPage(url) {
  var match = url[/* path */0];
  var exit = 0;
  if (match) {
    if (match[0] === "a-propos") {
      if (match[1]) {
        exit = 1;
      } else {
        return /* AboutPage */0;
      }
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    return /* GraphqlPage */[
            url[/* path */0],
            url[/* hash */1]
          ];
  }
  
}

function make(_, _$1) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* page */0];
      if (match) {
        return ReasonReact.element(/* None */0, /* None */0, GraphqlClientQuery.make(match[1], match[0], /* array */[]));
      } else {
        return ReasonReact.element(/* None */0, /* None */0, About.make(/* array */[]));
      }
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* page */urlToPage(ReasonReact.Router[/* dangerouslyGetInitialUrl */3](/* () */0)),
              /* todo */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      return /* Update */Block.__(0, [/* record */[
                  /* page */action[0],
                  /* todo */state[/* todo */1]
                ]]);
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return ReasonReact.Router[/* watchUrl */1]((function (url) {
                                  return Curry._1(self[/* send */4], /* Navigate */[urlToPage(url)]);
                                }));
                  }),
                ReasonReact.Router[/* unwatchUrl */2]
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.component = component;
exports.urlToPage = urlToPage;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 320
// module chunks = 0